import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import messages from 'i18n/messages/home';

import RibbonButton from 'common/components/button/RibbonButton';
import IconShared from 'assets/shared-ribbon/Share.svg?react';

import { ModalShare } from 'common/components';
import {
  checkDisabledShareButton,
  checkDisabledShareButtonForAPL,
} from './utils';

import * as memberActions from 'pages/company-profile/controllers/actions';

import * as companySelectors from 'pages/company-profile/controllers/selectors';
import userSelectors from '@redux/user/selectors';
import './styles.less';

const ENTITY_BY_PATH_NAME = {
  '/digital-media': 'digitalAssets',
  '/digital-media/assets': 'digitalAssets',
  '/digital-media/documents': 'digitalAssets',
  '/digital-media/multi-media': 'digitalAssets',
  '/favorite/favorite-assets': 'digitalAssets',
  '/products': 'products',
  '/favorite/favorite-products': 'products',
  '/folders': 'folders',
  '/folders/owned': 'folders',
  '/folders/shared': 'folders',
  '/favorite/favorite-folders': 'folders',
};

const ShareControl = (props) => {
  const { detailCurrentItemsSelection, type, assetDetailId } = props;

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const visibleModalHook = useState(false);
  const [visibleModal, setVisibleModel] = visibleModalHook;

  const memberInfo = useSelector(companySelectors.selectMemberProfile());
  const memberId = useSelector(userSelectors.makeSelectUserMemberId());

  const confirmShare = () => {
    setVisibleModel(true);
  };

  const getCurrentEntity = () => {
    const currentEntity = ENTITY_BY_PATH_NAME[pathname?.toLowerCase()];
    if (currentEntity) return currentEntity;
    return null;
  };

  const currentEntity = getCurrentEntity();

  const isEntitySharing = () => {
    if (assetDetailId) return memberInfo?.digitalAssets?.toLowerCase();
    if (memberInfo && memberInfo[currentEntity])
      return memberInfo[currentEntity]?.toLowerCase();
  };

  const isSharing = isEntitySharing();

  const isAPL = type === 'APL';

  const disabledShareButton = isAPL
    ? checkDisabledShareButtonForAPL(detailCurrentItemsSelection)
    : checkDisabledShareButton(detailCurrentItemsSelection, isSharing);

  useEffect(() => {
    if (!memberInfo) dispatch(memberActions.getMemberProfileHeader(memberId));
  }, [JSON.stringify(memberInfo), memberId, dispatch]);

  // const menuOptions = (
  //   <Menu>
  //     <Menu.Item key='share' style={{ backgroundColor: 'inherit' }}>
  //       <ButtonSmallIcon
  //         icon={<IconShared />}
  //         label={Messages.share}
  //         onClick={confirmShare}
  //         className='button-item-dropdown'
  //       />
  //     </Menu.Item>
  //     <Menu.Item key='email' style={{ backgroundColor: 'inherit' }}>
  //       <EmailControl disabled />
  //     </Menu.Item>
  //     <Menu.Item key='sendToFTP' style={{ backgroundColor: 'inherit' }}>
  //       <SendToFTP disabled />
  //     </Menu.Item>
  //     <Menu.Item key='sendToMessage' style={{ backgroundColor: 'inherit' }}>
  //       <SendToMessage disabled />
  //     </Menu.Item>
  //   </Menu>
  // );

  return (
    <>
      {/* <Dropdown overlay={menuOptions} arrow disabled={disabledShareButton}>
      </Dropdown> */}
      <RibbonButton
        icon={<IconShared style={{ height: 26 }} />}
        label={messages.share}
        onClick={confirmShare}
        disabled={disabledShareButton}
      />

      {visibleModal && (
        <ModalShare
          visibleHook={visibleModalHook}
          detailCurrentItemsSelection={detailCurrentItemsSelection}
          disabledEditableOption={isAPL}
        />
      )}
    </>
  );
};

ShareControl.propTypes = {
  detailCurrentItemsSelection: PropTypes.array,
};

export default ShareControl;
